import React, { Dispatch, SetStateAction } from 'react';

import { Select } from 'design-system';

import { filterProvider } from '../../providers';

import { Container } from './styles';

type PeriodFilterProps = {
  dataValue: number;
  setDataValue: Dispatch<SetStateAction<number>>;
};

const PeriodFilter: React.FC<PeriodFilterProps> = ({
  dataValue,
  setDataValue,
}) => {
  return (
    <Container>
      <Select
        size="sm"
        value={dataValue}
        onChange={(event) => {
          setDataValue(Number(event.currentTarget.value));
        }}
      >
        {filterProvider.map((filter) => (
          <option key={filter.value} value={filter.value}>
            {filter.label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default PeriodFilter;
